import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import { useTheme } from '../../../../../components/mui/Styles/index'
import { Grid, Paper } from '../../../../../components/mui/Core/index'

export function CustomerGroupAccountTable() {
  const theme = useTheme()
  const customerGroupAccount = useSelector((state) => state.customerGroup.customerGroupAccount)
  const isFetchingCustomerGroupAccount = useSelector(
    (state) => state.customerGroup.isFetchingCustomerGroupAccount,
  )

  const gridStyle = {
    backgroundColor: theme.palette.common.white,
    minHeight: '160px',
    height: isFetchingCustomerGroupAccount ? '400px' : 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
  }

  const rows = customerGroupAccount.map((row) => ({
    id: row.customerNumber,
    customerName: row.customerName,
    customerNumber: row.customerNumber,
  }))

  const columns = [
    { field: 'customerName', headerName: 'Customer', sortable: true, flex: 0.4, minWidth: 200 },
    {
      field: 'customerNumber',
      headerName: 'Account #',
      sortable: false,
      flex: 0.09,
      minWidth: 150,
    },
  ]

  return (
    <Grid sx={{ paddingTop: 1 }}>
      <Paper>
        <DataGrid
          sx={gridStyle}
          rows={rows}
          loading={isFetchingCustomerGroupAccount}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25, page: 0 },
            },
          }}
          pageSizeOptions={[25, 50]}
          slotProps={{
            pagination: {
              component: 'div',
              showLastButton: true,
              showFirstButton: true,
            },
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton',
            },
          }}
          disableRowSelectionOnClick
        />
      </Paper>
    </Grid>
  )
}

export default CustomerGroupAccountTable
